/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Close Icon component.
 *
 * ! NOTE: This Icon defines a non-standard color value within the DLS.
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const MaterialExitCloseIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z'
        fill={iconColor} />
    </svg>
  );
};
